export const StudentenWG = 'StudentenWG';
export const Zwischenmitte = 'Zwischenmitte';
export const Rentmate = 'Rentmate';
export const StanzaZoo = 'StanzaZoo';

export const StudentenWGColor = '#4fc1e9';
export const ZwischenmitteColor = '#e2e3dc';
export const RentmateBgColor = '#669fd5';
export const RentmateBtnColor = '#467db0';
